var NavbarVerticalStyle2Module = /** @class */ (function () {
    function NavbarVerticalStyle2Module() {
    }
    return NavbarVerticalStyle2Module;
}());
export { NavbarVerticalStyle2Module };
